import { is2xxStatus } from './AlertMessageLogic'

export default function messageOnEditCredentials(status) {
    let message

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos modificar as credenciais.'
            break
        case '2xx':
            message = 'Atualizamos as credenciais.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        case 422:
            message = 'Você não está autorizado. Credenciais de integração inválidas.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não atualizamos as credenciais. Por favor, tente novamente mais tarde.'
    }
    return message
}
